import { render, staticRenderFns } from "./FranksPattern.vue?vue&type=template&id=348d8817&scoped=true"
import script from "./FranksPattern.vue?vue&type=script&lang=js"
export * from "./FranksPattern.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348d8817",
  null
  
)

export default component.exports